"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.endpointWeightsOperation = void 0;
/** Get the endpoint price list for rate limits and cost. */
exports.endpointWeightsOperation = {
    method: 'GET',
    name: 'endpointWeights',
    id: 'endpointWeights',
    groupName: 'utils',
    urlPathPattern: '/info/endpointWeights',
    getRequestUrlParams: getRequestUrlParams,
    deserializeRequest: deserializeRequest,
    serializeRequest: serializeRequest,
    deserializeResponse: deserializeResponse,
};
// Methods
function getRequestUrlParams() {
    return {};
}
function serializeRequest() {
    return undefined;
}
function deserializeRequest() {
    return {};
}
function deserializeResponse(jsonResponse) {
    return jsonResponse;
}
//# sourceMappingURL=endpointWeightsOperation.js.map